// extracted by mini-css-extract-plugin
module.exports = {"calendar":"DateModal-module__calendar___2dOZI","footer":"DateModal-module__footer___8x3bA","modal":"DateModal-module__modal___kc3oY"};